(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["angel-archive"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('angel-archive')) {
    customElements.define('angel-archive', class extends HTMLElement {
      connectedCallback() {
        this.feed = this.querySelector('.aa-feed');
        this.fallback = this.querySelector('.aa-brand-grid');
        this.photos = [...this.querySelectorAll('[data-aa-brand]')];
        this.filters = this.querySelector('.aa-filters');
        this.empty = this.querySelector('[data-aa-empty]');
        this.dialog = this.querySelector('.aa-lightbox');
        this.filter = 'all';
        this.frame = null;
        this.handleClick = this.handleClick.bind(this);
        this.addEventListener('click', this.handleClick);
        this.observer = new MutationObserver(() => this.schedule());
        this.observe();
        this.sync();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        this.removeEventListener('click', this.handleClick);
        if (this.dialog?.open) this.dialog.close();
      }
      observe() {
        this.observer.observe(this.feed, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'class'] });
      }
      schedule() {
        if (this.frame !== null) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
      }
      sync() {
        this.observer.disconnect();
        const list = this.feed.querySelector('.switch-apps-gallery-main-grid > ul');
        const community = list ? [...list.children].filter(node => !node.hasAttribute('data-aa-brand') && node.querySelector('.switch-apps-gallery-item img[src]')) : [];
        const target = community.length ? list : this.fallback;
        const ordered = [];
        let brandIndex = 0;
        let communityIndex = 0;
        while (brandIndex < this.photos.length || communityIndex < community.length) {
          if (brandIndex < this.photos.length) ordered.push(this.photos[brandIndex++]);
          for (let i = 0; i < 2 && communityIndex < community.length; i++) ordered.push(community[communityIndex++]);
        }
        ordered.forEach((node, index) => {
          if (target.children[index] !== node) target.insertBefore(node, target.children[index] || null);
        });
        this.photos.forEach(node => { node.hidden = this.filter === 'community'; });
        community.forEach(node => { node.hidden = this.filter === 'brand'; });
        this.fallback.hidden = !!community.length || this.filter === 'community' || !this.photos.length;
        this.filters.hidden = !community.length && !this.photos.length;
        const visible = (this.filter === 'community' ? 0 : this.photos.length) + (this.filter === 'brand' ? 0 : community.length);
        const ready = !this.feed.querySelector('.switch-apps-customer-gallery') || !!this.feed.querySelector('[data-switch-apps-gallery-render].rendered');
        this.toggleAttribute('data-aa-ready', ready);
        this.empty.hidden = !!visible || !ready;
        const message = this.empty.dataset[this.filter];
        if (this.empty.textContent !== message) this.empty.textContent = message;
        this.observe();
      }
      handleClick(event) {
        const filterButton = event.target.closest('[data-aa-filter]');
        if (filterButton) {
          this.filter = filterButton.dataset.aaFilter;
          this.filters.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button === filterButton)));
          this.sync();
        }
        const openLink = event.target.closest('[data-aa-open]');
        if (openLink && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && typeof this.dialog.showModal === 'function') {
          event.preventDefault();
          const image = openLink.querySelector('img').cloneNode();
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.loading = 'eager';
          image.src = openLink.href;
          this.dialog.querySelector('.aa-expanded-photo').replaceChildren(image);
          this.dialog.showModal();
        }
        if (event.target.closest('[data-aa-close]') || event.target === this.dialog) this.dialog.close();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["angel-drop-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('angel-drop')) {
    customElements.define('angel-drop', class extends HTMLElement {
      connectedCallback() {
        this.stop();
        const date = this.dataset.date.trim();
        const time = this.dataset.time.trim();
        this.digits = this.querySelector('.angel-drop__digits');
        this.status = this.querySelector('.angel-drop__status');
        this.dateLabel = this.querySelector('[data-date-label]');
        if (!date || !time) return this.showStatus(this.dataset.soon);
        try {
          const input = `${date}T${time}:00`;
          if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:00$/.test(input)) throw new Error('Invalid date');
          const desired = Date.parse(`${input}Z`);
          if (!Number.isFinite(desired)) throw new Error('Invalid date');
          const formatter = new Intl.DateTimeFormat('en-GB', {timeZone: this.dataset.timezone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'});
          const localISO = timestamp => {
            const parts = Object.fromEntries(formatter.formatToParts(timestamp).map(p => [p.type, p.value]));
            return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}`;
          };
          let target = desired;
          for (let i = 0; i < 4; i++) target += desired - Date.parse(`${localISO(target)}Z`);
          if (localISO(target) !== input) throw new Error('Invalid local time');
          this.target = target;
          this.dateLabel.textContent = new Intl.DateTimeFormat('en-GB', {timeZone: this.dataset.timezone, weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true, timeZoneName: 'short'}).format(target);
          this.tick();
          if (this.target > Date.now()) this.interval = setInterval(() => this.tick(), 1000);
        } catch {
          this.showStatus(this.dataset.editor === 'true' ? this.dataset.invalid : this.dataset.soon);
        }
      }
      tick() {
        const remaining = Math.max(0, Math.ceil((this.target - Date.now()) / 1000));
        if (!remaining) { this.stop(); this.showStatus(this.dataset.ended); return; }
        const units = {days: Math.floor(remaining / 86400), hours: Math.floor(remaining % 86400 / 3600), minutes: Math.floor(remaining % 3600 / 60), seconds: remaining % 60};
        for (const [unit, value] of Object.entries(units)) this.querySelector(`[data-unit="${unit}"]`).textContent = String(value).padStart(2, '0');
        this.digits.hidden = false;
        this.status.hidden = true;
      }
      showStatus(message) { this.digits.hidden = true; this.status.hidden = false; this.status.textContent = message; }
      stop() { if (this.interval) clearInterval(this.interval); this.interval = null; }
      disconnectedCallback() { this.stop(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
